export class CourseStatus {
    courseStatusName: string;
    status: boolean;
    id: number;
}